export default class fryingpanHeaderManager {
  constructor(param, scroll) {
    this.param = param
    this.scroll = scroll

    this.isNavOpen = false
  }

  init() {
    if(this.param.displayType === "pc") {
      this.button = document.querySelector('.js-header-button')
      this.headarea = document.getElementById('l-header-title')

      this.button.addEventListener('click', (e) => {
        e.stopPropagation()
        this.switchNavi()
      })
      this.headarea.addEventListener('click', (e) => {
        e.stopPropagation()
        this.switchNavi()
      })

    }
  }

  switchNavi() {
    if(this.isNavOpen) {
      this.button.classList.remove('is-active')
      TweenMax.to('#l-header-body__navi', 1.0, { 
        y: 0, 
        ease: Power4.easeOut, 
        delay: 0.1, 
        onComplete: () => {
          this.headarea.classList.remove('is-active')
        } 
      })
      this.isNavOpen = false

    } else {
      this.button.classList.add('is-active')
      this.headarea.classList.add('is-active')
      TweenMax.to('#l-header-body__navi', 1.0, { y: 130, ease: Power4.easeOut, delay: 0.2 })

      this.isNavOpen = true
    }
  }
}